import { Entity } from "./entity"
import { ProductMake, ProductStatus, ProductType, ReservationStatus } from "./enum-type";

export interface Product extends Entity {
  laverieId: string
  storageDepotId: string
  productModelId: string
  model: string
  price: number
  aquaNb: number
  serialNb: string
  compteur: number
  bonEntreeNb: number
  bonEntreeDate: string
  destructionDate: Date
  notificationEnabled: boolean
  productMake: ProductMake
  productType: ProductType
  productStatus: ProductStatus
  reservationStatus: ReservationStatus
  location: string
  title?: string
}

export class ProductExport {
  prdts: Product[];
}

export function getProductExport(products: Product[]): ProductExport {
  const productsExport = new ProductExport();
  productsExport.prdts = products;
  return productsExport;
}